module.exports = __webpack_public_path__ + "static/img/1.ce08ce3d.png";